import { listaErrores } from "helpers/helpers";
import {
  SolicitudAgregarReporte,
  SolicitudObtenerReportes,
} from "interfaces/reportes/reportesInterface";
import {
  getDetallesReporte,
  getHistorialReporte,
  getMotivosService,
  getReporteTribunalService,
  postReporteTribunalService,
} from "services/reportes/reportesService";
import { setIsLoading } from "store";
import {
  onLoadDataReporte,
  onLoadDetalleReporte,
  onLoadHistorialReporte,
  onLoadLstReportes,
  onLoadMotivos,
  onLoadReporteSeleccionado,
  onResetAll,
  onResetReporteSelected,
  onSuccessSaveReporte,
} from "store/reportes/reportesSilce";
import Swal from "sweetalert2";
import { useGeneralStore } from "./generalesStore";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import { useUiStore } from "./useUiStore";

export const useReportesStore = () => {
  const dispatch = useAppDispatch();
  const { resetCarpetaJudicial } = useGeneralStore();
  const { changeTotalPage } = useUiStore();
  const {
    lstMotivos,
    lstReportes,
    consultaReporte,
    reporteSelected,
    detalleReporte,
    historialReporte,
    successSaveReporte,
  } = useAppSelector((state) => state.reportes);

  const startGetMotivos = () => {
    getMotivosService()
      .then(({ data }) => {
        dispatch(onLoadMotivos(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setReporteSelected = (data: any) => {
    dispatch(onLoadReporteSeleccionado(data));
  };
  const resetReporteSelected = () => {
    dispatch(onResetReporteSelected());
  };

  const saveReporte = (body: SolicitudAgregarReporte) => {
    postReporteTribunalService(body)
      .then(({ data }) => {
        dispatch(setIsLoading(false));
        isSuccessSaveReporte(true);
        resetCarpetaJudicial();
        Swal.fire({
          title: "Correcto",
          text: `Su reporte ha sido registrado con el número ${data.data.seguimiento.numeroReporte} / ${data.data.seguimiento.anioReporte} para dar seguimiento del mismo ingrese a la sección "Mis reportes > Seguimiento".`,
          icon: "success",
          confirmButtonText: "Aceptar",
        });
      })
      .catch((err) => {
        console.log(err?.response);
        let mensaje = '';
        if (typeof err?.response?.data?.data === 'string' || err?.response?.data?.data instanceof String) {
          mensaje = err?.response?.data?.data;
        } 
        if (err?.response?.data?.error_msg) {
          if (mensaje == '') {
            mensaje = err?.response?.data?.error_msg;
          } else {
            mensaje += ', ' + err?.response?.data?.error_msg;
          }
        }
        if (err?.response?.data?.error_data) {
          if (mensaje == '') {
            mensaje = err?.response?.data?.error_data;
          } else {
            mensaje += ', ' + err?.response?.data?.error_data;
          }
        }
        Swal.fire({
          title: `Error`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "error",
          confirmButtonText: "Aceptar",
          html: `
          <style>
            h4, h5{
              font-family: arial;
              color: #545454;
            }
          </style>
          <h4>${mensaje || "Hubo un problema"}</h4>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
        dispatch(setIsLoading(false));
        // isSuccessSaveReporte(true);
        // resetCarpetaJudicial();
      });
  };

  const startGetLstReportes = (body: SolicitudObtenerReportes) => {
    dispatch(setIsLoading(true));
    getReporteTribunalService(body)
      .then(({ data }) => {
        dispatch(onLoadDataReporte(body));
        dispatch(onLoadLstReportes(data.data.data));
        changeTotalPage(data.data.total);
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        Swal.fire({
          title: `Advertencia`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "error",
          confirmButtonText: "Aceptar",
          html: `
          <h4>${err?.response?.data?.error_msg || "Hubo un problema"}</h4>
          <h5>${err.response.data.data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        dispatch(setIsLoading(false));
      });
  };

  const startGetDetalleReporte = (body: number) => {
    getDetallesReporte(body)
      .then(({ data }) => {
        dispatch(onLoadDetalleReporte(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetHistorialReporte = (body: number) => {
    getHistorialReporte(body)
      .then(({ data }) => {
        dispatch(onLoadHistorialReporte(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const isSuccessSaveReporte = (status: boolean) =>
    dispatch(onSuccessSaveReporte(status));
  const resetAll = () => dispatch(onResetAll());

  return {
    /**Propiedades */
    lstMotivos,
    lstReportes,
    detalleReporte,
    consultaReporte,
    reporteSelected,
    historialReporte,
    successSaveReporte,
    /**Métodos */
    saveReporte,
    startGetMotivos,
    setReporteSelected,
    startGetLstReportes,
    resetReporteSelected,
    startGetDetalleReporte,
    startGetHistorialReporte,
    isSuccessSaveReporte,
    resetAll,
  };
};
